<template>
  <div class="item-box">
    <div class="item-con">
      <div class="left">
        <div class="no">
          <van-tag v-if="coupon.validStatus==2" round type="primary" color="#969799">{{ coupon.ticketTypeName }}</van-tag>
          <van-tag v-else round type="primary">{{ coupon.ticketTypeName }}</van-tag>
          <span class="kahao"> {{ coupon.ticketNo }}</span></div>
        <!-- <div>{{ coupon.ticketTypeName }}</div> -->
        <div class="value">余额 <span>{{ coupon.currentValue }}</span></div>
        <div>{{ coupon.invalidReason }}</div>
        <div class="date">有效期至{{ coupon.endUseDate }}</div>
      </div>
      <div class="btn">
        <van-button plain type="danger" size="mini" round @click="remove(coupon)"> 解绑 </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CouponItem",
  props: {
    coupon: {
      currentValue: 0,
      endUseDate: "",
      invalidReason: "",
      ticketNo: "",
      ticketTypeCode: "",
      ticketTypeName: "",
      unitName: "",
      validStatus: 0,
    },
  },
  data() {
    return {
      imgs: "",
    };
  },
  methods:{
    remove(item){
      this.$emit("on-remove",item);
    }

  }
};
</script>

<style lang="less" scoped>
.item-box {
  padding: 8px 15px 2px 15px;

}
.item-box .item-con {
  display: flex;
  padding: 12px;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  background-color: #fff;
  .left{
    flex: 1;
    font-size: 14px;
    .no{
      margin-bottom: 6px;
      line-height: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .van-tag{
        padding-left: 8px;
        padding-right: 8px;        
      }
    }
    .kahao{
      display: inline-block;
      padding-left: 8px;
    }
    .value span {
      font-weight: bold;
    }
    .date{
      font-size: 12px;
      color: #969799;
      //padding-top: 5px;
      //margin-top: 5px;
    }
  }
  .btn{
    .van-button {
      width: 50px;
    }
  }
}
</style>
